import { Injectable } from "@angular/core";
import { of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AvailableAccount } from "../accounts/AvailableAccount";
import { AuthHandlerService } from "../handlers/auth-handler.service";
import { SessionService } from "../session.service";
import { LocalStorageService } from "../storage/local-storage.service";
import { UserDTO } from "./User";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private AuthHandlerService: AuthHandlerService,
    private SessionService: SessionService,
    private LocalStorageService: LocalStorageService,
  ) {}

  login(email: String, password: String) {
    return this.AuthHandlerService.authPost({
      username: email,
      password,
    }).pipe(
      map((result) => {
        const user = result as unknown as UserDTO;
        this.SessionService.setUser(user);
        if (user.accounts.length) {
          const account = this.getAccount();
          this.SessionService.setCurrentAccount(account);
        }
      }),
    );
  }

  logout() {
    this.SessionService.logout();
  }

  authenticate(authToken: string) {
    return this.AuthHandlerService.authGet(authToken).pipe(
      map(
        (result) => {
          const user = result as unknown as UserDTO;
          let accountUser;
          this.SessionService.setUser(user);
          if (this.LocalStorageService.accountID) {
            accountUser = this.getAccount(
              Number.parseInt(this.LocalStorageService.accountID),
            );
            this.SessionService.setCurrentAccount(accountUser);
          } else if (user.accounts.length) {
            accountUser = this.getAccount();
            this.SessionService.setCurrentAccount(accountUser);
          }
        },
        (err: any) => {
          throwError(err);
        },
      ),
      catchError((err) => throwError(err)),
    );
  }

  requestResetPassword(email: string) {
    return this.AuthHandlerService.passwordRequest(email);
  }

  resetPassword(password: string, userID: string, resetToken: string) {
    return this.AuthHandlerService.passwordResetPut(
      password,
      userID,
      resetToken,
    );
  }

  getUserDataWithResetToken(resetToken: string) {
    return this.AuthHandlerService.passwordResetGet(resetToken);
  }

  getUserDataWithActivateToken(activateToken: string) {
    return this.AuthHandlerService.activateGet(activateToken);
  }

  activate(password: string, userID: string, activateToken: string) {
    return this.AuthHandlerService.activatePut(
      password,
      userID,
      activateToken,
    );
  }

  private getAccount(accountID?: number): AvailableAccount {
    let account;
    if (accountID) {
      account = this.SessionService.availableAccounts?.find(
        (availableAccount: AvailableAccount) =>
          availableAccount.accountID === accountID,
      );
      if (!account) {
        account = this.SessionService.availableAccounts![0];
      }
    } else {
      account = this.SessionService.availableAccounts![0];
    }

    return account!;
  }
}
